import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { OrderWithContext } from '@/models';

@Component({
  name: 'CmgCheckoutPaymentIssueModal',
})
export default class CmgCheckoutPaymentIssueModal extends Vue {
  isSubmitting = false;

  get visible(): boolean {
    return this.$appStore.state.ui.modals.checkoutPaymentIssue.visible;
  }

  get args() {
    return this.$appStore.state.ui.modals.checkoutPaymentIssue.args;
  }

  get order(): OrderWithContext | null {
    return (this.args && this.args.order) || null;
  }

  get isDelivery(): boolean {
    return !!this.args && this.args.isDelivery;
  }

  get formattedPrice(): string {
    if (!this.order) {
      return '';
    }

    return this.$services.utils.formatPrice(this.order.order.orderPreDiscountSubTotalAmount);
  }

  onTryAgain() {
    if (!this.args) {
      return;
    }
    this.args.onTryAgain();
  }

  onClickSwitchToPayInStore() {
    if (!this.args) {
      return;
    }

    this.args.onClickSwitchToPayInStore();
  }

  onClose() {
    if (this.args && this.args.onClose) {
      this.args.onClose();
    }

    this.close();
  }

  private close() {
    this.$services.ui.setModalVisibility('checkoutPaymentIssue', false);
    this.$services.ui.focusBack();
  }
}
